import vendor from './vendor.json';
import product from './product.json';

export const staticData = { vendor, product };
